import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.classList.toggle("dark", document.documentElement.classList.contains("dark"))
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  // Close when clicking the backdrop (outside the dialog box)
  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
